import i18n from 'modules/core/lib/i18n'

export interface ValidationResult {
  isValid: boolean
  error?: string
}

export const validatePayrollField = (fieldName: string, fieldValue: string): ValidationResult => {
  // Number field validations
  if (fieldName === 'company_number_of_health_insurer') {
    if (fieldValue && fieldValue.length > 8) {
      return {
        isValid: false,
        error: i18n.t('employee_form.payroll_data.errors.length_error', {
          max_number: 8,
        }),
      }
    }
  } else if (fieldName === 'annual_tax_allowance') {
    const numValue = Number(fieldValue)
    if (fieldValue && (numValue < 0 || numValue > 999999999)) {
      return {
        isValid: false,
        error: i18n.t('employee_form.payroll_data.errors.range_error', {
          min: 0,
          max: 999999999,
        }),
      }
    }
  } else if (fieldName === 'requested_annual_allowance') {
    const numValue = Number(fieldValue)
    if (fieldValue && (numValue < 0 || numValue > 999999999)) {
      return {
        isValid: false,
        error: i18n.t('employee_form.payroll_data.errors.range_error', {
          min: 0,
          max: 999999999,
        }),
      }
    }
  } else if (fieldName === 'health_insurance_id') {
    const numValue = Number(fieldValue)
    if (fieldValue && (numValue < 1 || numValue > 999)) {
      return {
        isValid: false,
        error: i18n.t('employee_form.payroll_data.errors.range_error', {
          min: 1,
          max: 999,
        }),
      }
    }
  } else if (fieldName === 'monthly_tax_allowance') {
    const numValue = Number(fieldValue)
    if (fieldValue && (numValue < 0 || numValue > 999999999)) {
      return {
        isValid: false,
        error: i18n.t('employee_form.payroll_data.errors.range_error', {
          min: 0,
          max: 999999999,
        }),
      }
    }
  } else if (fieldName === 'tax_class') {
    const numValue = Number(fieldValue)
    if (fieldValue && (numValue < 0 || numValue > 6)) {
      return {
        isValid: false,
        error: i18n.t('employee_form.payroll_data.errors.range_error', {
          min: 0,
          max: 6,
        }),
      }
    }
  }

  // String field validations
  else if (fieldName === 'academic_title') {
    if (fieldValue && fieldValue.length > 20) {
      return {
        isValid: false,
        error: i18n.t('employee_form.payroll_data.errors.length_error', {
          max_number: 20,
        }),
      }
    }
  } else if (fieldName === 'place_of_birth') {
    if (fieldValue && fieldValue.length > 34) {
      return {
        isValid: false,
        error: i18n.t('employee_form.payroll_data.errors.length_error', {
          max_number: 34,
        }),
      }
    }
  } else if (fieldName === 'child_tax_allowance') {
    const childAllowanceTaxPattern = /^[1-9]?[0-9]{1}(\.[0,5])?$/
    if (fieldValue && !childAllowanceTaxPattern.test(fieldValue)) {
      return {
        isValid: false,
        error: i18n.t('employee_form.payroll_data.errors.child_allowance_tax_error'),
      }
    }
  } else if (fieldName === 'factor') {
    const factorValue = parseFloat(fieldValue)
    if (fieldValue && (factorValue < 0.001 || factorValue > 0.999)) {
      return {
        isValid: false,
        error: i18n.t('employee_form.payroll_data.errors.range_error', {
          min: 0.001,
          max: 0.999,
        }),
      }
    }
  }

  return { isValid: true }
}
